import { render } from "./BonusItem.vue?vue&type=template&id=6efd6162"
import script from "./BonusItem.vue?vue&type=script&lang=js"
export * from "./BonusItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__